var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubendweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_27187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#F97316",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6956 21.2299L26.3619 28.4475C25.707 29.0918 24.5721 28.6408 24.5721 27.7171V23.5928H18.6353C18.0547 23.5928 17.5876 23.1331 17.5876 22.5617V18.4374C17.5876 17.866 18.0547 17.4063 18.6353 17.4063H24.5721V13.282C24.5721 12.3626 25.7027 11.9072 26.3619 12.5516L33.6956 19.7692C34.1015 20.173 34.1015 20.8261 33.6956 21.2299ZM20.3814 28.2327V26.5142C20.3814 26.2307 20.1456 25.9986 19.8575 25.9986H16.1907C15.418 25.9986 14.7938 25.3842 14.7938 24.6238V16.3752C14.7938 15.6148 15.418 15.0005 16.1907 15.0005H19.8575C20.1456 15.0005 20.3814 14.7685 20.3814 14.4849V12.7665C20.3814 12.4829 20.1456 12.2509 19.8575 12.2509H16.1907C13.8771 12.2509 12 14.0983 12 16.3752V24.6238C12 26.9008 13.8771 28.7481 16.1907 28.7481H19.8575C20.1456 28.7481 20.3814 28.5162 20.3814 28.2327Z",
    fill: "#F97316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_27187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubendweb);
export default __webpack_public_path__ + "static/media/subendweb.fa1bf7e4e156f86fd5fe67aabd74d4db.svg";
export { ForwardRef as ReactComponent };